import { render, staticRenderFns } from "./publicBtn.vue?vue&type=template&id=38da401e&scoped=true&"
import script from "./publicBtn.vue?vue&type=script&lang=js&"
export * from "./publicBtn.vue?vue&type=script&lang=js&"
import style0 from "./publicBtn.vue?vue&type=style&index=0&id=38da401e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da401e",
  null
  
)

export default component.exports